<template>
  <div class="login-page top-bar-page page-padding-top">
    <top-bar :title="i18n.t('editSafePassword.title')"   @back="back"></top-bar>


    <div class="login-form">
    
      <div class="form-label" v-show="isSetPassword">{{$t('editSafePassword.label1')}}</div>
      <div class="form-item flex-center" v-show="isSetPassword" >
        <div class="input">
          <input :type="showOldPassword ? 'text' : 'password'" inputmode="decimal" v-model="form.oldPassword" :placeholder="i18n.t('editSafePassword.labelPlaceholder1')"/>
        </div>
        <div class="adot" @click="changeShowOldPassword">
          <img :src="showOldPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>
    
      <div class="form-label">{{$t('editSafePassword.label2')}}</div>
      <div class="form-item flex-center" id="passwordDom">
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" inputmode="decimal" v-model="form.password" :placeholder="i18n.t('editSafePassword.labelPlaceholder2')"/>
        </div>
        <div class="adot"  @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="">
        </div>
      </div>

      <div class="form-label">{{$t('editSafePassword.label3')}}</div>
      <div class="form-item flex-center" >
        <div class="input">
          <input :type="showPassword2 ? 'text' : 'password'" inputmode="decimal"  v-model="form.password2" :placeholder="i18n.t('editSafePassword.labelPlaceholder3')"/>
        </div>
        <div class="adot" @click="changeshowPassword2">
          <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

      <div class="form-label" v-if="captchaEnabled && userPhone && userEmail">{{$t('editSafePassword.label4')}}</div>
      <div class="form-item flex-center"  v-if="captchaEnabled && userPhone && userEmail">
        <div class="input">
          <input type="text" v-model="typeName" readonly @click="showTypeModal"/>
        </div>
      </div>

      <div class="form-label" v-if="captchaEnabled">{{$t('editPassword.label4')}}</div>
      <div class="form-item flex-center" v-if="captchaEnabled" >
        <div class="input"> 
          <input type="number" inputmode="decimal"  v-model="form.code" :placeholder="i18n.t('editPassword.labelPlaceholder4')">
        </div>
        <div class="adot long" >
          <span class="gray" v-if="isDisabled">{{$t('editPassword.resend')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('editPassword.send')}}</span>
        </div>
      </div>

    </div>

    <Button class="login-btn" @click="submit" :disabled="btnDisabled">{{i18n.t(`editSafePassword.btn`)}}</Button>

    <Popup v-model="showModal" position="bottom">
      <Picker
        :columns="typeList"
        valueKey="text"
        show-toolbar
        :confirm-button-text="$t('common.ensure')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="chooseType"
        @cancel="cancel"
      ></Picker>
    </Popup>
  </div>
</template>
<script>
  import topBar from '@/components/topBar'
  import { Button, Popup, Picker } from 'vant'
  import { configList, userInfo } from '@/api/user'
  import { sendAuthCode, sendAuthSms } from '@/api/login'
  import { editSafePassword,CheckPassword } from '@/api/setting'
  import { isCaptchaEnabled, normalizeCaptchaEnable } from '@/utils/captcha'
  export default {
    components: {
      Button,
      Popup,
      topBar,
      Picker
    },
    data() {
      return {
        form: {
          oldPassword: '',
          password: '',
          password2: '',
          code: '',
          codeType: 'email'
        },
        // 是否设置密码
        isDisabled: false,
        isSetPassword: false,
        backUrl: require('../../assets/imgs/icon-back.png'),
        passwordUrl: require('../../assets/imgs/icon-password.png'),
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        checkedUrl: require('../../assets/imgs/icon-check.png'),
        checkedUrl2: require('../../assets/imgs/icon-check2.png'),
        warningUrl: require('../../assets/imgs/icon-warning.png'),
        showPassword: false,
        showPassword2: false,
        showOldPassword: false,
        passwordAuthList: [],
        userEmail: '',
        userPhone: '',
        typeName: this.$t('editSafePassword.type1'),
        typeList: [
          {
            value: 'email',
            text: this.$t('editSafePassword.type1'),
          },
          {
            value: 'phone',
            text: this.$t('editSafePassword.type2'),
          },
        ],
        showModal: false,
        sendTime: '',
        captchaReady: false,
      }
    },
    computed: {
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable, this.captchaReady)
      },
      btnDisabled() {
        if (!this.captchaReady) {
          return true
        }

        // 如果验证码关闭,不需要验证码
        if (!this.captchaEnabled) {
          if (this.isSetPassword) {
            return !(this.form.password && this.form.password2 && this.form.oldPassword && (this.form.password === this.form.password2))
          } else {
            return !(this.form.password && this.form.password2 && (this.form.password === this.form.password2))
          }
        }
        
        if (this.isSetPassword) {
          return !(this.form.password && this.form.password2 && this.form.oldPassword && this.form.code && (this.form.password === this.form.password2))
        } else {
          return !(this.form.password && this.form.password2 && this.form.code && (this.form.password === this.form.password2))
        }
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    mounted() {
     
      this.init()
    },
    methods: {
      init() {
        this.syncCaptchaConfig()

        CheckPassword().then(res => {
          if (res.code === 0) {
            this.isSetPassword = true
          } else {
            this.isSetPassword = false
          }
        })


        userInfo().then(res => {
          this.userPhone = res.data.Phone 
          this.userEmail = res.data.Email
        })
      },
      syncCaptchaConfig() {
        configList().then(res => {
          if (res && res.captcha_enable !== undefined) {
            this.$store.state.captchaEnable = normalizeCaptchaEnable(res.captcha_enable.Value)
          }
        }).catch(() => {}).then(() => {
          this.captchaReady = true
        })
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      submit() {
        if (!this.captchaReady) {
          return
        }

        if(this.isSetPassword) {
          if (!this.form.oldPassword) {
            this.$toast.fail( this.i18n.t('editSafePassword.labelPlaceholder1'))
            return
          }
        }

        if (!this.form.password) {
          this.$toast.fail( this.i18n.t('editSafePassword.labelPlaceholder2'))
          return
        }
        if (!this.form.password2) {
          this.$toast.fail(this.i18n.t('editSafePassword.labelPlaceholder3'))
          return
        }

        let form = new FormData()
        form.append('OldPassword', this.form.oldPassword)
        form.append('NewPassword', this.form.password)
        form.append('ConfirmPassword', this.form.password2)
        form.append('Code', this.form.code)
        editSafePassword(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('editSafePassword.success'))
            this.back()
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      changeShowOldPassword() {
        this.showOldPassword = !this.showOldPassword
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      resend() {
        if (!this.captchaEnabled || this.isDisabled) {
          return
        } 
        if (this.userPhone && this.userEmail) {
          if (this.form.codeType == 'email') {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          }
        } else {
          if (this.userEmail) {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          } 
        }
      },
      sendPhoneSms(){
        let form = new FormData()
        form.append('Phone', this.userPhone)
        form.append('Type', 6)
        sendAuthSms(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail(){
        let form = new FormData()
        form.append('Email', this.userEmail)
        form.append('Type', 6)
        sendAuthCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      showTypeModal() {
        this.showModal = true
      },
      chooseType(item) {
        this.form.codeType = item.value
        this.typeName = item.text
        this.showModal = false
      },
      cancel() {
        this.showModal = false
      }
    },
  }
</script>
